import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { Result } from '@/entities/Result';
import { seasonInfoKeys } from '@/hooks/teamLeagueSeasonInfo/seasonInfoKeys';
import { getTeamLeagueSeasonInfo } from '@/infrastructure/network/data/seasons/season-info';
import { TeamLeagueSeasonInfoDto } from '@/infrastructure/network/dto/TeamLeagueSeasonInfoDto';
import { useOrganizationStore } from '@/store/organization-store';

export const useSeasonInfoQuery = (teamLeagueUuid: string, seasonUuid?: string | null): UseQueryResult<Result<TeamLeagueSeasonInfoDto>> => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: seasonInfoKeys.seasonInfo(store.organizationUuid, teamLeagueUuid, seasonUuid),
		queryFn: () => getTeamLeagueSeasonInfo({ teamLeagueUuid, organizationUuid: store.organizationUuid, seasonUuid }),
		enabled: !!teamLeagueUuid && !!store.organizationUuid
	});
};
